<template>
  <div class="device-status">
    <!-- <h2>设备状态页</h2> -->
    <div v-if="isFailedCheckAllDeviceStatus" class="StatusBox">
      <!-- 设备不可用 -->
       当前设备不可用 ❌
    </div>
    <div v-else  class="StatusBox">
      <!-- 设备可用 -->
       设备正常运行 ✅ 
    </div>
    <p>当前位置：{{ outdoorRunnControlData.VenueName }}</p>
    <p>当前项目：{{ currentProject }}{{ registryTypeName }}</p>


    <!-- <van-button type="default" size="large" style="margin: 20px 0;" @click="selfCheck">当前设备运行正常</van-button> -->

<!--v-if="!isFailedCheckAllDeviceStatus" v-else-->
    <div class="btn-group" >
        <van-button class="btn-group-li" type="primary" @click="startTest" style="width: 100%;">开启测试</van-button>
        <van-button :disabled="!!+isBusing" class="btn-group-li"  type="info" @click="showProjectSelector"  style="width: 100%;">切换项目</van-button>
        <!-- <van-button class="btn-group-li"  type="warning" @click="enterConfig"  style="width: 100%;">进入配置</van-button> -->
        <van-button :disabled="!!+isBusing" class="btn-group-li" type="primary" @click="toCloudPlatform" style="width: 100%;">云台调试</van-button>
        <!-- <van-button :disabled="isBusing" class="btn-group-li"  type="danger" @click="showAuxiliary"  style="width: 100%;">辅助功能</van-button> -->
    </div>
    
    <div class="btn-group" >
        <van-button class="btn-group-li" type="primary" @click="loadDeviceStatus" style="width: 100%;">设备自检</van-button>
    </div>



    <div class="collapsebox">
      <van-collapse v-model="activeNames">
        <van-collapse-item title="质检结果详情：" name="1">
            <ul v-if="Object.keys(checkAllDeviceStatusList).length>0">
              <li v-for="(value, key) in checkAllDeviceStatusList" :key="key">
                <strong>{{ key }}</strong>: {{ value }}
                <span v-if="value !== '00'" style="color: red;"> ❌ 质检异常</span>
                <span v-else style="color: green;"> ✅ 正常</span>
              </li>
            </ul>
            <ul v-else>
              <van-empty image="error" description="暂无数据" />
            </ul>
        </van-collapse-item>
      </van-collapse>
        <!-- <h3>质检结果详情：</h3> -->
    </div>



    <!-- 辅助功能弹窗 -->
    <van-popup v-model="showAux" position="bottom" :style="{ height: '30%' }">
      <h3>辅助功能：</h3>
      <van-cell title="画线功能" @click="auxAction('draw')" />
      <van-cell title="录像回看" @click="auxAction('replay')" />
      <van-cell title="系统重启" @click="auxAction('restart')" />
    </van-popup>
  </div>
</template>

<script>
import req from '@/utils/request2.js';
export default {
  name: 'DeviceStatus',
  data() {
    return {
      currentProject: '',
      registryTypeName:"--",
      projectList: [
				{ projectName: "引体向上", projectCode: "PullUp" },
				{ projectName: "立定跳远", projectCode: "Jump" },
				{ projectName: "坐位体前屈", projectCode: "SitAndReach" },
				{ projectName: "仰卧起坐", projectCode: "SitUp" },
				{ projectName: "体重/身高", projectCode: "HeightWeight" },
				{ projectName: "肺活量", projectCode: "VitalCapacity" },
				{ projectName: "50米", projectCode: "FiftyMeters" },
				{ projectName: "100米", projectCode: "HundredMeters" },
				{ projectName: "800米", projectCode: "EigthHunderMeters" },
				{ projectName: "1000米", projectCode: "ThousandMeters" },
				{ projectName: "耐力跑", projectCode: "Endurance" },
				// { projectName: "2000米", projectCode: "TThousandMeters" },
			],
      registryTypeList:[
        {"registryName":"发令模式","registryType":"none"},
        {"registryName":"自主模式","registryType":"self"}
      ],


      location:"--",
      showAux: false,
      outdoorRunnControlData:{},
      checkAllDeviceStatusList:{},
      isFailedCheckAllDeviceStatus:true, //  false可以使用  true 不可以使用
      activeNames:["1"],
      isBusing:0
    }
  },
 async mounted() {
     this.outdoorRunnControlData =  JSON.parse(localStorage.getItem('outdoorRunnControlData'))
   await this.checkAreaStatus()
   await this.loadDeviceStatus()
   await this.getProjectByAreaId()
  },
  methods: {
    // 检查当前机器状态 
    async checkAreaStatus(){
        // let data = {}
       await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/checkAreaStatus`,
          data:{
           areaId:this.outdoorRunnControlData.VenueId
          },
        }).then(res=>{
          this.isBusing =res.isBusing
          console.log("检查当前机器状态",res);
          
        })
    },
    async getProjectByAreaId(){
        // let data = {}
       await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/getProjectByAreaId`,
          data:{
           areaId:this.outdoorRunnControlData.VenueId
          },
        }).then(res=>{
          this.projectList.forEach(el=>{
            if(el.projectCode==res.body.projectType){
              this.currentProject = el.projectName
            }
          })
          this.outdoorRunnControlData.projectCode = res.body.projectType
          this.outdoorRunnControlData.registryType = res.body.registryType
          localStorage.setItem('outdoorRunnControlData',JSON.stringify(
            this.outdoorRunnControlData
          ))

          this.registryTypeList.forEach(el=>{
            if(el.registryType==res.body.registryType){
              this.registryTypeName = el.registryName
            }
          })
          console.log(res.body.projectType);
          
        })
    },
    // 判断质检是否失败
     isQualityCheckFailed(data) {
      const body = data;

      // 情况1：body 为空、null、undefined 或 {}
      if (!body || Object.keys(body).length === 0) {
        return true;
      }

      // 情况2：body 中有任何一个值不是 "00"
      return !Object.values(body).every(value => value === "00");
    },
   async loadDeviceStatus() {
      // 模拟加载设备状态（实际调用接口）
      this.$toast.loading({ message: '加载中...', duration: 0 })
     await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/checkAllDeviceStatus`,
          data:{
           areaId:this.outdoorRunnControlData.VenueId
          },
        }).then(res=>{
          this.$toast.clear()
          if(res.status=='00'){
            let data = res.body
            this.checkAllDeviceStatusList = res.body

            // this.checkAllDeviceStatusList = {"xxxxxxxxxxxxxxxxxxx":"00","ddddddddddddddddddd":"00"}
            // let data = {"xxxxxxxxxxxxxxxxxxx":"00","ddddddddddddddddddd":"00"}
          // 判断质检结果
           this.isFailedCheckAllDeviceStatus = this.isQualityCheckFailed(data);
          }
        }).catch(()=>{
        this.$toast.clear()
        })
    },
    selfCheck() {
      this.$toast('正在执行自检...')
      // 调用自检接口
    },

async checkNeedSport() {
      this.$toast.loading({ message: '查询设备状态...', duration: 0 })
     await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/checkNeedSport`,
          data:{
           areaId:this.outdoorRunnControlData.VenueId
          },
        }).then(res=>{
          this.$toast.clear()
          if(res.status=='00'){

        // 0:代表不需要 1：代表需要 &&this.currentProject!==''
            if (res.needCheck==1&&this.currentProject!=='') {
             this.$router.push('/outdoorRunning/DeviceIssueOrder')
            }else{
              this.$toast('暂不需要发令！');
            }
          }
        }).catch(()=>{
        this.$toast.clear()
        })
    },
    
    async startTest() {
     await this.checkNeedSport()
      // this.$toast.loading({ message: '查询设备状态...', duration: 0 })
      
    },
    showProjectSelector() {
        this.$router.push('/outdoorRunning/SelectProject')
    },
    enterConfig() {
      this.$toast('进入配置页面...') // 可跳转到配置页
    },
    showAuxiliary() {
      this.showAux = true
    },
    toCloudPlatform() {
        this.$router.push("/outdoorRunning/cloudPlatform")
    },
    
    auxAction(action) {
      this.showAux = false
      switch (action) {
        case 'draw':
          this.$toast('画线功能开启')
          break
        case 'replay':
          this.$toast('录像回看')
          break
        case 'restart':
          this.$toast('系统即将重启')
          break
      }
    }
  }
}
</script>

<style lang="less" scoped>
.device-status {
  padding: 20px;
}
.btn-group {
  /* display: flex;
  flex-wrap: wrap;
  justify-content: space-between; */
  .btn-group-li{
    margin: 6px 0;
  }
}
.StatusBox{
  width: 100%;
  height: 100px;
  line-height: 100px;
  text-align: center;
  background-color: #fff;
  border-radius: 12px;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
}
.collapsebox{
  border-radius: 12px;
}
</style>